import { merchantKnowledgeAvailabilitySchema } from "@redotech/shopper-agent-knowledge-common/merchant-knowledge-view";
import { merchantKnowledgeIdFormat } from "@redotech/shopper-agent-knowledge-id";
import * as z from "zod";

/** Enable, disable, draft, or schedule. Cannot disturb the article's text. */
export const setKnowledgeArticleAvailability = {
  name: "setKnowledgeArticleAvailability" as const,
  input: z
    .object({
      id: merchantKnowledgeIdFormat.schema,
      availability: merchantKnowledgeAvailabilitySchema,
    })
    .strict(),
  /** Echoes what committed; nothing else about the article can have changed. */
  output: merchantKnowledgeAvailabilitySchema,
};
